import * as Yup from 'yup';
import { v4 as uuidv4 } from 'uuid';

import { capitalize } from 'utils/string';
import { PaymentMethodType } from 'types';

import { FormValues } from './types';

export const getInitialValues = ({
  data,
  amount,
  tipAmount,
  processingFeeAmount,
}: {
  amount?: number;
  data?: FormValues;
  tipAmount?: number;
  processingFeeAmount?: number;
}): FormValues =>
  data ?? {
    type: '',
    id: uuidv4(),
    tip: tipAmount,
    amount: amount || 0,
    processingFee: processingFeeAmount,
  };

export const getValidationSchema = ({
  maxAmount,
  maxTipAmount,
  maxProcessingFeeAmount,
}: {
  maxAmount: number;
  maxTipAmount: number;
  maxProcessingFeeAmount: number;
}) =>
  Yup.object().shape({
    type: Yup.string().required(),
    tip: Yup.number().max(maxTipAmount),
    amount: Yup.number().required().max(maxAmount),
    processingFee: Yup.number().max(maxProcessingFeeAmount),
  });

export const getPaymentTypeOptions = (types: PaymentMethodType[]) =>
  types.map((value) => ({ value, label: capitalize(value) }));
